import { fetcher } from '@commenda/utils';

import {
  IDeleteIndirectTaxCredentialParams,
  IDeleteIndirectTaxCredentialResponse,
} from './types';

export async function deleteIndirectTaxCredential(
  credentialId: string,
  params: IDeleteIndirectTaxCredentialParams,
  token?: string
): Promise<{
  success: boolean;
  data?: IDeleteIndirectTaxCredentialResponse;
  error?: string;
}> {
  try {
    const queryParams = new URLSearchParams({
      corporationId: params.corporationId.toString(),
    }).toString();

    const response = await fetcher(
      `new-sales-tax/credentials/${credentialId}?${queryParams}`,
      { method: 'DELETE' },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to delete credential',
      };
    }

    const data: IDeleteIndirectTaxCredentialResponse = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to delete credential';
    return {
      success: false,
      error: errorMessage,
    };
  }
}
